import React, { useMemo } from "react";
import { Card, GridLegacy } from "@mui/material";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import CardBody from "../../../../components/Card/CardBody";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import MenuSyncSettings from "../MenuSyncSettings";

function Cashdesk() {
  const apiMethod = useMemo(
    () => [
      { value: "TABLE", label: "Tafel orders" },
      { value: "ORDER", label: "Reguliere orders" },
    ],
    []
  );

  const apiMethodOptions = useMemo(() => convertObjectToSelectOptions(apiMethod), []);

  const { menukaartVestigingId } = useFormContext();

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormSwitchTC
              name={"apiaccounts__useTest"}
              tDefault={"Gebruik test omgeving"}
              tKey={"vestigingen.form.apiaccounts.label.useTest"}
            />
            <FormSelectTC
              name={"apiaccounts__cashdeskOrderMode"}
              options={apiMethodOptions}
              tDefault={"Cashdesk order mode"}
              tKey={"vestigingen.form.apiaccounts.label.cashdeskOrderMode"}
            />
            <FormTextTC
              name={"apiaccounts__cashdeskUsername"}
              tDefault={"Gebruikersnaam"}
              tKey={"vestigingen.form.cashDesk.label.cashdeskUsername"}
            />
            <FormTextTC
              name={"apiaccounts__cashdeskPassword"}
              tDefault={"Password"}
              tKey={"vestigingen.form.cashDesk.label.cashdeskPassword"}
            />
            <FormTextTC
              name={"apiaccounts__cashdeskStoreCode"}
              tDefault={"StoreCode"}
              tKey={"vestigingen.form.cashDesk.label.cashdeskStoreCode"}
            />
            <FormTextTC
              name={"apiaccounts__cashdeskImportUrl"}
              tDefault={"Import URL"}
              tKey={"vestigingen.form.cashDesk.label.cashdeskImportUrl"}
            />
            <FormSwitchTC
              name={"mplusOCnt"}
              tDefault={"Send OCnt"}
              tKey={"vestigingen.form.mplusapi.label.mplusOCnt"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
          </GridLegacy>
          <MenuSyncSettings />
        </CardBody>
      </Card>
    </div>
  );
}

export default Cashdesk;
